// Delete Icon for buttons
// fill は currentColor を使い、親の color から継承する
// (CustomButton: 白テキスト → 白アイコン / IconButton: グレー/エラー hover で色変化)
export const ButtonDeleteIcon = ({
  width = 14,
  height = 16,
}: { width?: number | string; height?: number | string } = {}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.91304 16C2.46349 16 2.07865 15.8259 1.75851 15.4778C1.43837 15.1296 1.27831 14.7111 1.27831 14.2222V2.66667C1.04672 2.66667 0.852594 2.58148 0.695931 2.41111C0.539269 2.24074 0.460938 2.02963 0.460938 1.77778C0.460938 1.52593 0.539269 1.31481 0.695931 1.14444C0.852594 0.974074 1.04672 0.888889 1.27831 0.888889H4.54778C4.54778 0.637037 4.62611 0.425926 4.78278 0.255556C4.93944 0.0851852 5.13356 0 5.36515 0H8.63463C8.86622 0 9.06034 0.0851852 9.217 0.255556C9.37367 0.425926 9.452 0.637037 9.452 0.888889H12.7215C12.9531 0.888889 13.1472 0.974074 13.3039 1.14444C13.4605 1.31481 13.5388 1.52593 13.5388 1.77778C13.5388 2.02963 13.4605 2.24074 13.3039 2.41111C13.1472 2.58148 12.9531 2.66667 12.7215 2.66667V14.2222C12.7215 14.7111 12.5614 15.1296 12.2413 15.4778C11.9211 15.8259 11.5363 16 11.0867 16H2.91304ZM4.54778 11.5556C4.54778 11.8074 4.62611 12.0185 4.78278 12.1889C4.93944 12.3593 5.13356 12.4444 5.36515 12.4444C5.59674 12.4444 5.79087 12.3593 5.94753 12.1889C6.10419 12.0185 6.18252 11.8074 6.18252 11.5556V5.33333C6.18252 5.08148 6.10419 4.87037 5.94753 4.7C5.79087 4.52963 5.59674 4.44444 5.36515 4.44444C5.13356 4.44444 4.93944 4.52963 4.78278 4.7C4.62611 4.87037 4.54778 5.08148 4.54778 5.33333V11.5556ZM7.81726 11.5556C7.81726 11.8074 7.89559 12.0185 8.05225 12.1889C8.20892 12.3593 8.40304 12.4444 8.63463 12.4444C8.86622 12.4444 9.06034 12.3593 9.217 12.1889C9.37367 12.0185 9.452 11.8074 9.452 11.5556V5.33333C9.452 5.08148 9.37367 4.87037 9.217 4.7C9.06034 4.52963 8.86622 4.44444 8.63463 4.44444C8.40304 4.44444 8.20892 4.52963 8.05225 4.7C7.89559 4.87037 7.81726 5.08148 7.81726 5.33333V11.5556Z"
      fill="currentColor"
    />
  </svg>
);

// Dropdown Arrow Icon
export const DropDownArrowIcon = (props: any) => (
  <svg
    {...props}
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.31853 8.09591L0.747503 1.99634C0.670895 1.91213 0.610492 1.81809 0.566295 1.7142C0.522098 1.61064 0.5 1.4995 0.5 1.38077C0.5 1.14364 0.57322 0.93748 0.719659 0.762294C0.866098 0.587431 1.05909 0.5 1.29864 0.5H13.0347C13.2742 0.5 13.4672 0.588399 13.6137 0.765198C13.7601 0.941674 13.8333 1.14767 13.8333 1.38319C13.8333 1.44223 13.7507 1.64661 13.5854 1.99634L8.0148 8.09591C7.88693 8.23625 7.75463 8.33869 7.61792 8.40321C7.4812 8.46774 7.33078 8.5 7.16667 8.5C7.00255 8.5 6.85213 8.46774 6.71542 8.40321C6.5787 8.33869 6.4464 8.23625 6.31853 8.09591Z"
      fill="#989898"
    />
  </svg>
);

// Required Icon
export const RequireIcon = () => (
  <svg
    width="11"
    height="20"
    viewBox="0 0 11 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.56818 13.75L1.56818 12.7273L7.65909 6.52273L8.65909 7.54545L2.56818 13.75ZM7.65909 13.75L1.56818 7.54545L2.56818 6.52273L8.65909 12.7273L7.65909 13.75ZM0.818182 10.0909C0.818182 9.84091 0.892045 9.63068 1.03977 9.46023C1.1875 9.28977 1.40909 9.20455 1.70455 9.20455C2.01136 9.20455 2.23864 9.28977 2.38636 9.46023C2.53788 9.63068 2.61364 9.84091 2.61364 10.0909C2.61364 10.3295 2.53788 10.5303 2.38636 10.6932C2.23864 10.8523 2.01136 10.9318 1.70455 10.9318C1.40909 10.9318 1.1875 10.8523 1.03977 10.6932C0.892045 10.5303 0.818182 10.3295 0.818182 10.0909ZM4.15909 13.5227C4.15909 13.2841 4.23295 13.0814 4.38068 12.9148C4.52841 12.7443 4.75 12.6591 5.04545 12.6591C5.34091 12.6591 5.56629 12.7443 5.72159 12.9148C5.87689 13.0814 5.95455 13.2841 5.95455 13.5227C5.95455 13.7614 5.87689 13.9659 5.72159 14.1364C5.56629 14.303 5.34091 14.3864 5.04545 14.3864C4.75 14.3864 4.52841 14.303 4.38068 14.1364C4.23295 13.9659 4.15909 13.7614 4.15909 13.5227ZM4.15909 6.75C4.15909 6.51136 4.23295 6.30871 4.38068 6.14205C4.52841 5.97159 4.75 5.88636 5.04545 5.88636C5.34091 5.88636 5.56629 5.97159 5.72159 6.14205C5.87689 6.30871 5.95455 6.51136 5.95455 6.75C5.95455 6.98864 5.87689 7.19318 5.72159 7.36364C5.56629 7.5303 5.34091 7.61364 5.04545 7.61364C4.75 7.61364 4.52841 7.5303 4.38068 7.36364C4.23295 7.19318 4.15909 6.98864 4.15909 6.75ZM7.47727 10.0909C7.47727 9.84091 7.55492 9.63068 7.71023 9.46023C7.86553 9.28977 8.09091 9.20455 8.38636 9.20455C8.68182 9.20455 8.9072 9.28977 9.0625 9.46023C9.2178 9.63068 9.29545 9.84091 9.29545 10.0909C9.29545 10.3295 9.2178 10.5303 9.0625 10.6932C8.9072 10.8523 8.68182 10.9318 8.38636 10.9318C8.09091 10.9318 7.86553 10.8523 7.71023 10.6932C7.55492 10.5303 7.47727 10.3295 7.47727 10.0909Z"
      fill="#DA384C"
    />
  </svg>
);

// Search Icon for buttons
export const ButtonSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.93198 13.0129C6.50892 13.0129 5.30378 12.5193 4.31656 11.5323C3.32948 10.545 2.83594 9.3399 2.83594 7.91684C2.83594 6.49379 3.32948 5.28865 4.31656 4.30143C5.30378 3.31434 6.50892 2.8208 7.93198 2.8208C9.35503 2.8208 10.5602 3.31434 11.5474 4.30143C12.5345 5.28865 13.028 6.49379 13.028 7.91684C13.028 8.51198 12.9282 9.08038 12.7284 9.62205C12.5286 10.1637 12.262 10.6348 11.9286 11.0354L16.7236 15.8304C16.8391 15.9457 16.8981 16.0907 16.9007 16.2654C16.9034 16.4401 16.8443 16.5878 16.7236 16.7085C16.603 16.8292 16.4566 16.8896 16.2845 16.8896C16.1125 16.8896 15.9662 16.8292 15.8455 16.7085L11.0505 11.9135C10.6339 12.2575 10.1547 12.5268 9.61302 12.7212C9.07135 12.9157 8.51101 13.0129 7.93198 13.0129ZM7.93198 11.7631C9.00573 11.7631 9.91517 11.3905 10.6603 10.6452C11.4056 9.90004 11.7782 8.99059 11.7782 7.91684C11.7782 6.84309 11.4056 5.93365 10.6603 5.18851C9.91517 4.44323 9.00573 4.07059 7.93198 4.07059C6.85823 4.07059 5.94878 4.44323 5.20365 5.18851C4.45837 5.93365 4.08573 6.84309 4.08573 7.91684C4.08573 8.99059 4.45837 9.90004 5.20365 10.6452C5.94878 11.3905 6.85823 11.7631 7.93198 11.7631Z"
      fill="white"
    />
  </svg>
);

// Clear Icon for buttons (Refresh/Reset icon)
export const ButtonClearIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m19 8-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4z"
      fill="currentColor"
    />
  </svg>
);

// Send Mail Icon for password reset button
export const SendMailIcon = () => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.916992 12.5418V0.458496L15.2599 6.50016L0.916992 12.5418ZM2.16699 10.6668L12.042 6.50016L2.16699 2.3335V5.41037L6.68616 6.50016L2.16699 7.58995V10.6668Z"
      fill="#3F97D5"
    />
  </svg>
);

// Add more icons here as needed
// export const ButtonEditIcon = () => (...);
// export const ButtonSaveIcon = () => (...);
// export const ButtonCancelIcon = () => (...);

export const LinkIcon = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.30775 17C1.80258 17 1.375 16.825 1.025 16.475C0.675 16.125 0.5 15.6974 0.5 15.1923V1.80775C0.5 1.30258 0.675 0.875 1.025 0.525C1.375 0.175 1.80258 0 2.30775 0H7.86525C8.07808 0 8.25633 0.0718332 8.4 0.2155C8.5435 0.359 8.61525 0.537167 8.61525 0.75C8.61525 0.962833 8.5435 1.141 8.4 1.2845C8.25633 1.42817 8.07808 1.5 7.86525 1.5H2.30775C2.23075 1.5 2.16025 1.53208 2.09625 1.59625C2.03208 1.66025 2 1.73075 2 1.80775V15.1923C2 15.2692 2.03208 15.3398 2.09625 15.4038C2.16025 15.4679 2.23075 15.5 2.30775 15.5H15.6923C15.7692 15.5 15.8398 15.4679 15.9038 15.4038C15.9679 15.3398 16 15.2692 16 15.1923V9.63475C16 9.42192 16.0718 9.24367 16.2155 9.1C16.359 8.9565 16.5372 8.88475 16.75 8.88475C16.9628 8.88475 17.141 8.9565 17.2845 9.1C17.4282 9.24367 17.5 9.42192 17.5 9.63475V15.1923C17.5 15.6974 17.325 16.125 16.975 16.475C16.625 16.825 16.1974 17 15.6923 17H2.30775ZM16 2.55375L7.24625 11.3077C7.10775 11.4461 6.93367 11.5169 6.724 11.5203C6.5145 11.5234 6.33725 11.4526 6.19225 11.3077C6.04742 11.1627 5.975 10.9871 5.975 10.7808C5.975 10.5744 6.04742 10.3988 6.19225 10.2537L14.9462 1.5H11.75C11.5372 1.5 11.359 1.42817 11.2155 1.2845C11.0718 1.141 11 0.962833 11 0.75C11 0.537167 11.0718 0.359 11.2155 0.2155C11.359 0.0718332 11.5372 0 11.75 0H16.596C16.8538 0 17.0689 0.0862494 17.2413 0.258749C17.4138 0.431083 17.5 0.646166 17.5 0.903999V5.75C17.5 5.96283 17.4282 6.141 17.2845 6.2845C17.141 6.42817 16.9628 6.5 16.75 6.5C16.5372 6.5 16.359 6.42817 16.2155 6.2845C16.0718 6.141 16 5.96283 16 5.75V2.55375Z"
      fill="#3E3E3E"
    />
  </svg>
);
export const CustomCloseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99952 8.05327L1.92652 13.1265C1.78802 13.2649 1.61394 13.3357 1.40427 13.339C1.19477 13.3422 1.01752 13.2714 0.872524 13.1265C0.72769 12.9815 0.655273 12.8059 0.655273 12.5995C0.655273 12.3932 0.72769 12.2175 0.872524 12.0725L5.94577 6.99952L0.872524 1.92652C0.73419 1.78802 0.663357 1.61394 0.660023 1.40427C0.656857 1.19477 0.72769 1.01752 0.872524 0.872524C1.01752 0.72769 1.19319 0.655273 1.39952 0.655273C1.60586 0.655273 1.78152 0.72769 1.92652 0.872524L6.99952 5.94577L12.0725 0.872524C12.211 0.73419 12.3851 0.663357 12.5948 0.660023C12.8043 0.656857 12.9815 0.72769 13.1265 0.872524C13.2714 1.01752 13.3438 1.19319 13.3438 1.39952C13.3438 1.60586 13.2714 1.78152 13.1265 1.92652L8.05327 6.99952L13.1265 12.0725C13.2649 12.211 13.3357 12.3851 13.339 12.5948C13.3422 12.8043 13.2714 12.9815 13.1265 13.1265C12.9815 13.2714 12.8059 13.3438 12.5995 13.3438C12.3932 13.3438 12.2175 13.2714 12.0725 13.1265L6.99952 8.05327Z"
      fill="#3E3E3E"
    />
  </svg>
);

// Shrink Icon for chat window (6:4 ratio with inner square at bottom right)
export const ShrinkIcon = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="22"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <rect x="15" y="7" width="6" height="6" rx="1" fill="currentColor" />
  </svg>
);

// Expand Icon for chat window (6:4 ratio with inner rectangle)
export const ExpandIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="22"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
    />
    <rect x="3.5" y="3.5" width="17" height="9" rx="1" fill="currentColor" />
  </svg>
);

// ArrowBackIos Icon from MUI
export { default as ArrowBackIosIcon } from "@mui/icons-material/ArrowBackIos";

export const CheckCircleFilled = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9375 21C17.9081 21 21.9375 16.9706 21.9375 12C21.9375 7.02944 17.9081 3 12.9375 3C7.96694 3 3.9375 7.02944 3.9375 12C3.9375 16.9706 7.96694 21 12.9375 21ZM17.4678 9.53033C17.7607 9.23744 17.7607 8.76256 17.4678 8.46967C17.1749 8.17678 16.7001 8.17678 16.4072 8.46967L11.4375 13.4393L9.46783 11.4697C9.17494 11.1768 8.70006 11.1768 8.40717 11.4697C8.11428 11.7626 8.11428 12.2374 8.40717 12.5303L10.9072 15.0303C11.2001 15.3232 11.6749 15.3232 11.9678 15.0303L17.4678 9.53033Z"
      fill="#007C57"
    />
  </svg>
);

export const Warning = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.36308 20.5003C4.19358 20.5003 4.04133 20.4589 3.90633 20.376C3.77133 20.2932 3.66641 20.184 3.59158 20.0483C3.51358 19.9136 3.47066 19.7678 3.46283 19.6108C3.455 19.4538 3.49733 19.2983 3.58983 19.1443L12.1506 4.3563C12.2432 4.2023 12.3591 4.08846 12.4981 4.0148C12.6372 3.94113 12.7837 3.9043 12.9376 3.9043C13.0914 3.9043 13.2379 3.94113 13.3771 4.0148C13.5161 4.08846 13.6319 4.2023 13.7246 4.3563L22.2853 19.1443C22.3778 19.2983 22.4202 19.4538 22.4123 19.6108C22.4045 19.7678 22.3616 19.9136 22.2836 20.0483C22.2087 20.184 22.1038 20.2932 21.9688 20.376C21.8338 20.4589 21.6816 20.5003 21.5121 20.5003H4.36308ZM5.38758 19.0003H20.4876L12.9376 6.0003L5.38758 19.0003ZM12.9376 17.808C13.1664 17.808 13.3582 17.7306 13.5131 17.5758C13.6679 17.421 13.7453 17.2291 13.7453 17.0003C13.7453 16.7715 13.6679 16.5796 13.5131 16.4248C13.3582 16.27 13.1664 16.1925 12.9376 16.1925C12.7087 16.1925 12.5169 16.27 12.3621 16.4248C12.2072 16.5796 12.1298 16.7715 12.1298 17.0003C12.1298 17.2291 12.2072 17.421 12.3621 17.5758C12.5169 17.7306 12.7087 17.808 12.9376 17.808ZM12.9378 15.1925C13.1505 15.1925 13.3286 15.1207 13.4721 14.977C13.6157 14.8332 13.6876 14.655 13.6876 14.4425V10.9425C13.6876 10.73 13.6157 10.552 13.4718 10.4083C13.328 10.2645 13.1498 10.1925 12.9373 10.1925C12.7247 10.1925 12.5466 10.2645 12.4031 10.4083C12.2594 10.552 12.1876 10.73 12.1876 10.9425V14.4425C12.1876 14.655 12.2595 14.8332 12.4033 14.977C12.5472 15.1207 12.7253 15.1925 12.9378 15.1925Z"
      fill="#DA7238"
    />
  </svg>
);

export const ExternalLinkIcon = ({ color = '#666666' }: { color?: string }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 30 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" fill="none" />
    <polyline
      points="27 12 36 12 36 21"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <polyline
      points="32 26 32 34 14 34 14 16 22 16"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <line
      x1="24"
      y1="24"
      x2="35"
      y2="13"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </svg>
);

export const Delete = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.937 13.0543L7.86402 18.1275C7.72552 18.2658 7.55144 18.3367 7.34177 18.34C7.13227 18.3432 6.95502 18.2723 6.81002 18.1275C6.66519 17.9825 6.59277 17.8068 6.59277 17.6005C6.59277 17.3942 6.66519 17.2185 6.81002 17.0735L11.8833 12.0005L6.81002 6.9275C6.67169 6.789 6.60086 6.61492 6.59752 6.40525C6.59436 6.19575 6.66519 6.0185 6.81002 5.8735C6.95502 5.72867 7.13069 5.65625 7.33702 5.65625C7.54336 5.65625 7.71902 5.72867 7.86402 5.8735L12.937 10.9468L18.01 5.8735C18.1485 5.73517 18.3226 5.66433 18.5323 5.661C18.7418 5.65783 18.919 5.72867 19.064 5.8735C19.2089 6.0185 19.2813 6.19417 19.2813 6.4005C19.2813 6.60683 19.2089 6.7825 19.064 6.9275L13.9908 12.0005L19.064 17.0735C19.2024 17.212 19.2732 17.3861 19.2765 17.5958C19.2797 17.8053 19.2089 17.9825 19.064 18.1275C18.919 18.2723 18.7434 18.3448 18.537 18.3448C18.3307 18.3448 18.155 18.2723 18.01 18.1275L12.937 13.0543Z"
      fill="#3E3E3E"
    />
  </svg>
);

// Sparkles Icon (lucide-react Sparkles と同形)。AI バッジ等で使用
export const SparklesIcon = ({ size = 11 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.582a.5.5 0 0 1 0 .962L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
    <path d="M20 3v4" />
    <path d="M22 5h-4" />
    <path d="M4 17v2" />
    <path d="M5 18H3" />
  </svg>
);
